import { BusinessRegion, BusinessRegionResponseData, CitySearchSuggestion, CustomBaseStore } from '@city/const';
import { GeoPoint } from '@core/const';
import { CustomPointOfService } from '@shop/const';
import { StateUtils } from '@spartacus/core';

export const CITY_FEATURE = 'city';
export const BUSINESS_REGION = '[City] Business Region';
export const CURRENT_POINT_BUSINESS_REGION = '[CUSTOM CITY] Business Region for current point';
export const BASE_STORE = '[City] Base Store';
export const BASE_STORE_SHOPS = '[City] Base Store Shops';
export const LOGIN = '[City] Login';
export const CITY_SEARCH = '[City] City Search';

export interface StateWithCity {
  [CITY_FEATURE]: CityState;
}

export interface CityState {
  businessRegion: StateUtils.LoaderState<BusinessRegion>;
  currentPointBusinessRegion: StateUtils.LoaderState<BusinessRegionResponseData>;
  baseStores: StateUtils.LoaderState<CustomBaseStore[]>;
  baseStoreShops: StateUtils.EntityLoaderState<CustomPointOfService[]>;
  activeBaseStore: string;
  tempBaseStore: string;
  userGeoPoint: GeoPoint;
  city: { noDeliveryIsShowing: boolean };
  citySuggestions: StateUtils.LoaderState<CitySearchSuggestion[]>;
}

export interface CityPersistenceState {
  businessRegion: BusinessRegion;
  activeBaseStore: string;
  noDeliveryIsShowing: boolean;
}
